// If FastBundle is on this page
if (window.FastBundleConf) {
  
  function init() {
    const containerElement = document.querySelector(':is(#rbr-container-element-false, #rbr-container-element-true):has(.rbr-addBundleBtn-container, .rbr-bap-new-footer)');
    if (!containerElement) {
      setTimeout(init, 500);
    } else {
      const buttons = document.querySelectorAll('.rbr-addBundleBtn-container, .rbr-bap-new-footer');
      for (const button of buttons) {
        button.setAttribute('role', 'button');
        button.setAttribute('tabindex', '0');
        button.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            button.click();
          }
        })
      }

      const selects = containerElement.querySelectorAll('select');
      for (const select of selects) {
        const placeholder = select.querySelector('option[value=""],option:not([value])');
        if (placeholder) {
          select.setAttribute('aria-label', placeholder.textContent);
        }
      }
    }
  }
  setTimeout(init, 500);
}
